import React, { useReducer } from "react";
import { Button, Typography, Modal } from "../../../core";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { MixStyle, theme } from "../../../styles";
import { FormOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { reducer, initialState } from "../../../hooks/modalReducer";
// import EditForm from "./UpdateProfileInfo";
import SizerEditForm from "../../../components/SizerEditForm";

const { colors } = theme;
const btnProps = {
  width: "150px",
  height: "30px",
  border: "2px solid #FF5687",
  radius: "5px",
  fontSize: "16px",
  weight: "600",
};
const StyledButton = styled(Button)`
  ${MixStyle.flexCenter};
`;
const Wraper = styled.div`
  .text-right {
    text-align: right;
  }
  svg {
    width: 20.12px;
    height: 20.12px;
    color: ${colors.Fiord};
    margin: 0px 5px;
  }
  h5 {
    margin: 30px 0px;
  }
  h5 > span {
    font-size: 16px;
    line-height: 24px;
    color: #6789c5;
    font-weight: normal;
  }
  .p-20 {
    padding: 20px;
  }
`;
const General = ({ SizerData }) => {
  let history = useHistory();

  function addProgram(params) {
    history.push("/add-program");
  }
  const editHandler = (params) =>
    dispatch({
      type: "MODAL_VIEW",
      payload: { flag: true, modal_name: "edit_buyer" },
    });
  const [state, dispatch] = useReducer(reducer, initialState);
  const [form] = Form.useForm();
  const onCreate = (values) => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const onCancel = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };

  return (
    <Wraper>
      <div className="text-right">
        <FormOutlined color="#404E67" onClick={editHandler} />
        <span>Edit</span>
      </div>
      <div className="p-20">
        <Typography
          color="#000000"
          letterSpacing="0.2"
          weight="bold"
          as="h2"
          align="center"
        >
          General
        </Typography>
        <div className="mt-50">
          <Typography as="h5" weight="500" color="#404E67">
            Name : <span>{SizerData.sizer_name}</span>
          </Typography>
          <Typography as="h5" weight="500" color="#404E67">
            Phone Number : <span>{SizerData.phone_no_sizer}</span>
          </Typography>
          <Typography as="h5" weight="500" color="#404E67">
            Address : <span>{SizerData.address_sizer}</span>
          </Typography>
          <Typography as="h5" weight="500" color="#404E67">
            STRN : <span>{SizerData.strn_sizer}</span>
          </Typography>
          <Typography as="h5" weight="500" color="#404E67">
            NTN : <span>{SizerData.ntn_sizer}</span>
          </Typography>
          <StyledButton
            {...btnProps}
            bg="#FF5687"
            onClick={addProgram}
            margin="0px auto 0px 0px"
          >
            Add Program
          </StyledButton>
        </div>
      </div>
      <Modal
        closable={true}
        footer={false}
        visible={state.visible}
        onCreate={onCreate}
        tittle=" Update Sizer Information"
        maxwidth="589px"
      >
        {/* <EditForm form={form} /> */}
        <SizerEditForm
          SizerId={{ id: SizerData.sizer_id }}
          onCreate={onCreate}
          onCancel={onCancel}
          form={form}
        />
      </Modal>
    </Wraper>
  );
};

export default General;
